import axios from 'axios';
import toast from 'react-hot-toast';

// Configuration de base
const api = axios.create({
  baseURL: 'https://www.kokbatay.com/api',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',  
  },
});

// Intercepteur pour les requêtes
api.interceptors.request.use(
  (config) => {
    // Ajouter le token d'authentification si disponible
    const token = localStorage.getItem('auth-storage');
    if (token) {
      try {
        const authData = JSON.parse(token);
        if (authData.state?.token) {
          config.headers.Authorization = `Bearer ${authData.state.token}`;
        }
      } catch (error) {
        console.error('Erreur lors du parsing du token:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }     
);

// Intercepteur pour les réponses
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;

    if (response) {
      const { status, data } = response;

      switch (status) {
        case 401:
          // Token expiré ou invalide
          localStorage.removeItem('auth-storage');
          console.log("Errur 401: ", data);
          
          // window.location.href = '/login';
          toast.error(data.error || 'Session expirée. Veuillez vous reconnecter.');
          break;

        case 403:
          toast.error('Accès refusé. Vous n\'avez pas les permissions nécessaires.');
          break;

        case 404:
          toast.error('Ressource non trouvée.');
          break;

        case 422:
          // Erreurs de validation
          if (data.details && Array.isArray(data.details)) {
            const errors = data.details.map(detail => detail.msg).join(', ');
            toast.error(errors);
          } else {
            toast.error(data.error || 'Données invalides');
          }
          break;

        case 500:
          toast.error('Erreur serveur. Veuillez réessayer plus tard.');
          break;

        default:
          toast.error(data.error || 'Une erreur est survenue');
      }
    } else {
      // Erreur réseau
      toast.error('Erreur de connexion. Vérifiez votre connexion internet.');
    }

    return Promise.reject(error);
  }
);

// Services API spécifiques
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  logout: () => api.post('/auth/logout'),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.put('/auth/change-password', data),
};

export const contactAPI = {
  sendMessage: (data) => api.post('/contact', data),
};


export const combatsAPI = {
  getAll: (params) => api.get('/combats', { params }),
  getById: (id) => api.get(`/combats/${id}`),
  create: (data) => api.post('/combats', data),
  update: (id, data) => api.put(`/combats/${id}`, data),
  delete: (id) => api.delete(`/combats/${id}`),
  setWinner: (id, winner) => api.post(`/combats/${id}/winner`, { winner }),
  getStyles: () => api.get('/combats/styles/available'),
};

export const betsAPI = {
  create: (data) => api.post('/bets', data),
  getMyBets: (params) => api.get('/bets/my-bets', { params }),
  getById: (id) => api.get(`/bets/${id}`),
  cancel: (id) => api.delete(`/bets/${id}`),
  getStats: () => api.get('/bets/stats/summary'),
  processWinnings: (combatId) => api.post('/bets/process-winnings', { combatId }),
};

export const paymentsAPI = {
  createDeposit: (data) => api.post('/payments/deposit', data),
  createWithdrawal: (data) => api.post('/payments/withdrawal', data),
  getStatus: (transactionId) => api.get(`/payments/status/${transactionId}`),
  getHistory: (params) => api.get('/payments/history', { params }),
  getStats: () => api.get('/payments/stats'),
  getBalance: () => api.get('/payments/balance'),
};

export const usersAPI = {
  getAll: (params) => api.get('/users', { params }),
  getById: (id) => api.get(`/users/${id}`),
  update: (id, data) => api.put(`/users/${id}`, data),
  toggleStatus: (id) => api.patch(`/users/${id}/toggle-status`),
  getStats: (id) => api.get(`/users/${id}/stats`),
  getBets: (id, params) => api.get(`/users/${id}/bets`, { params }),
  getTransactions: (id, params) => api.get(`/users/${id}/transactions`, { params }),
};

export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getCombatStats: (params) => api.get('/admin/stats/combats', { params }),
  getUserStats: (params) => api.get('/admin/stats/users', { params }),
  getTransactionStats: (params) => api.get('/admin/stats/transactions', { params }),
  getFinancialReport: (params) => api.get('/admin/reports/financial', { params }),
  getBetsReport: (params) => api.get('/admin/reports/bets', { params }),
};

export default api; 